import React from 'react';
import styled from 'styled-components';
import { NavigationItem } from '../Navigation/NavigationItem';
import { FlexRow } from '../FlexRow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHomeLgAlt } from '@fortawesome/pro-solid-svg-icons';

export interface IBreadcrumbsLink {
  href?: string;
  to?: string;
  text: string;
  children?: React.ReactNode;
}

interface IBreadcrumbsProps {
  homeLink: string;
  links: IBreadcrumbsLink[];
  separator?: string;
}

export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ homeLink, links, separator }) => (
  <FlexRow>
    <BreadcrumbsNavigationItem to={homeLink} text={''}>
      <FontAwesomeIcon icon={faHomeLgAlt} />
    </BreadcrumbsNavigationItem>
    <span>{separator || '/'}</span>
    {links.map((link, index) => (
      <React.Fragment key={index}>
        <BreadcrumbsNavigationItem {...link} />
        {index !== links.length - 1 && <span>{separator || '/'}</span>}
      </React.Fragment>
    ))}
  </FlexRow>
);

const BreadcrumbsNavigationItem = styled(NavigationItem)`
  color: ${(props) => props.theme.colors.black}
  :hover {
    color: ${(props) => props.theme.colors.primary};
    text-decoration: underline;
  }
`;
